<app-header-top [title]="'Modulo di Registrazione Zent'" [subtitle]="'Inserisci i dati della tua Impresa'"></app-header-top>

<div style="background: #f5f5f5">
   <div class="container">
      <form class="p-5 w-full mx-auto with-label"
            [formGroup]="frmGrpUser" (ngSubmit)="onSubmit()"
            autocomplete="off">

         <div formGroupName="esercizio" class="my-10">
            <h2>Ragione sociale impresa</h2>
            <section class="grid grid-cols-12 gap-4">

               <div class="col-span-6 lg:col-span-12">
                  <mat-label>Nome dell'impresa</mat-label>
                  <mat-form-field class="w-full" appearance="fill">
                     <input matInput type="text" formControlName="ragione_sociale" (blur)="patchNomeEsercizio()">
                     <mat-error *ngIf="frmGrpUser.get('esercizio')?.get('ragione_sociale')?.hasError('required')">
                        La Ragione Sociale è <strong>obbligatoria</strong>
                     </mat-error>
                  </mat-form-field>
               </div>

               <div class="col-span-6 lg:col-span-6">
                  <mat-label>Partita IVA o Codice Fiscale</mat-label>
                  <mat-form-field class="w-full" appearance="fill">
                     <input matInput type="text" formControlName="piva" minlength="11" maxlength="16">
                     <mat-error *ngIf="frmGrpUser.get('esercizio')?.get('piva')?.hasError('required')">
                        La Partita IVA è <strong>obbligatoria</strong>
                     </mat-error>
                  </mat-form-field>
               </div>

            </section>
         </div>

         <h2>Legale Rappresentante Impresa - Dati Personali</h2>
         <div class="grid grid-cols-12 gap-4">
            <div class="col-span-6 lg:col-span-4">
               <mat-label>Nome</mat-label>
               <mat-form-field class="w-full" appearance="fill">
                  <input matInput type="text" formControlName="first_name">
                  <mat-error *ngIf="frmGrpUser.get('first_name')?.hasError('required')">
                     Il Nome è <strong>obbligatorio</strong>
                  </mat-error>
               </mat-form-field>
            </div>

            <div class="col-span-6 lg:col-span-4">
               <mat-label>Cognome</mat-label>
               <mat-form-field class="w-full" appearance="fill">
                  <input matInput type="text" formControlName="last_name">
                  <mat-error *ngIf="frmGrpUser.get('last_name')?.hasError('required')">
                     Il Cognome è <strong>obbligatorio</strong>
                  </mat-error>
               </mat-form-field>
            </div>

            <div class="col-span-6 lg:col-span-4" formGroupName="profile">
               <mat-label>Data di Nascita</mat-label>
               <mat-form-field class="w-full" appearance="fill" >
                  <input matInput formControlName="data_nascita"
                         [matDatepicker]="dataNascita"
                         (dateChange)="onDataNascitaChange('change', $event)">
                  <mat-datepicker-toggle matSuffix [for]="dataNascita" tabindex="-1"></mat-datepicker-toggle>
                  <mat-datepicker #dataNascita></mat-datepicker>
                  <mat-error *ngIf="frmGrpUser.get('profile')?.get('data_nascita')?.hasError('required')">
                     La Data di Nascita è <strong>obbligatoria</strong>
                  </mat-error>
               </mat-form-field>
            </div>

         </div>

         <div formGroupName="profile" class="grid grid-cols-12 gap-4">
            <div class="col-span-6 lg:col-span-6">
               <mat-label>Codice Fiscale</mat-label>
               <mat-form-field class="w-full" appearance="fill">
                  <input matInput type="text" formControlName="codice_fiscale" minlength="16" maxlength="16">
                  <mat-error *ngIf="frmGrpUser.get('profile')?.get('codice_fiscale')?.hasError('required')">
                     Il Codice fiscale è <strong>obbligatorio</strong>
                  </mat-error>
               </mat-form-field>
            </div>

            <div class="col-span-6 lg:col-span-2">
               <mat-label>Prefisso Cellulare</mat-label>
               <mat-form-field class="w-full" appearance="fill" style="">
                  <input matInput type="text" formControlName="cellulare_prefix">
                  <mat-error *ngIf="frmGrpUser.get('profile')?.get('cellulare_prefix')?.hasError('required')">
                     Il prefisso è <strong>obbligatorio</strong>
                  </mat-error>
               </mat-form-field>
            </div>

            <div class="col-span-6 lg:col-span-4">
               <mat-label>Cellulare</mat-label>
               <mat-form-field class="w-full" appearance="fill">
                  <input matInput type="text" formControlName="cellulare">
                  <mat-error *ngIf="frmGrpUser.get('profile')?.get('cellulare')?.hasError('required')">
                     Il Numero di Cellulare è <strong>obbligatorio</strong>
                  </mat-error>
               </mat-form-field>
            </div>
         </div>


         <div class="grid grid-cols-12 gap-4 mt-5">
            <h2 class="col-span-12">Credenziali Account</h2>

            <div class="col-span-12 lg:col-span-3">
               <mat-label>E-mail</mat-label>
               <mat-form-field class="w-full" appearance="fill">
                  <input matInput type="email" formControlName="email" >
                  <mat-error *ngIf="frmGrpUser.get('email')?.hasError('email')">
                     Inserire un indirizzo email valido
                  </mat-error>
                  <mat-error *ngIf="frmGrpUser.get('email')?.hasError('required')">
                     L'email è <strong>obbligatoria</strong>
                  </mat-error>
               </mat-form-field>
            </div>

            <div class="col-span-12 lg:col-span-3">
               <mat-label>Conferma e-mail</mat-label>
               <mat-form-field class="w-full" appearance="fill">
                  <input matInput type="email" formControlName="confirm_email" >
                  <mat-error *ngIf="frmGrpUser.get('confirm_email')?.hasError('email')">
                     Inserire un indirizzo email valido
                  </mat-error>
                  <mat-error *ngIf="frmGrpUser.get('confirm_email')?.hasError('required')">
                     L'email è <strong>obbligatoria</strong>
                  </mat-error>
                  <mat-error *ngIf="frmGrpUser.hasError('not_same_email')">
                     Le email non corrispondono
                  </mat-error>
               </mat-form-field>
            </div>

            <div class="col-span-12 lg:col-span-3">
               <mat-label>Password</mat-label>
               <mat-form-field class="w-full" appearance="fill">
                  <input matInput [type]="hidepw ? 'password' : 'text'" formControlName="password" >
                  <button mat-icon-button matSuffix tabindex="-1"
                          (click)="clickVisibility($event)"
                          [attr.aria-label]="'Nascondi password'" [attr.aria-pressed]="hidepw">
                     <mat-icon>{{hidepw ? 'visibility_off' : 'visibility'}}</mat-icon>
                  </button>
                  <mat-error *ngIf="frmGrpUser.get('password')?.hasError('required')">
                     La password è <strong>obbligatoria</strong>
                  </mat-error>
                  <mat-hint>La password deve contenere almeno 8 caratteri alfanumerici</mat-hint>
               </mat-form-field>
            </div>

            <div class="col-span-12 lg:col-span-3">
               <mat-label>Ripeti password</mat-label>
               <mat-form-field class="w-full" appearance="fill">
                  <input matInput [type]="hidepw2 ? 'password' : 'text'" formControlName="confirm_password" autocomplete="off" >
                  <button mat-icon-button matSuffix tabindex="-1"
                          (click)="clickVisibility2($event)" [attr.aria-label]="'Nascondi password'" [attr.aria-pressed]="hidepw2">
                     <mat-icon>{{hidepw2 ? 'visibility_off' : 'visibility'}}</mat-icon>
                  </button>
                  <mat-error *ngIf="frmGrpUser.get('confirm_password')?.hasError('required')">
                     La password è <strong>obbligatoria</strong>
                  </mat-error>
                  <mat-error *ngIf="frmGrpUser.hasError('not_same_pswd')">
                     Le password non corrispondono
                  </mat-error>
               </mat-form-field>
            </div>
         </div>
         <mat-checkbox #checkTerms class="mr-3 bottom-0.5 cursor-pointer underline" color="primary" [checked]="termsConditionsAccepted" (change)="termsConditionsAccepted = checkTerms.checked"></mat-checkbox>
         <span class="text-center pt-1">Accetta <span (click)="popupTermsVisible = true" class="underline cursor-pointer">Termini e Condizioni di utilizzo</span></span>

         <!-- endregion punto vendita -->

         <div class="text-right mt-8">
            <div>
               <button class="ds-btn ds-btn-info self-end"
                       [disabled]="!termsConditionsAccepted"
                       (click)="clickConferma($event)">
                  <span>Registrati</span>
               </button>
            </div>
            <div *ngIf="termsConditionsAccepted" class="text-green-600">Hai accettato <a class="cursor-pointer my-5" (click)="popupTermsVisible = true">i termini e le condizioni di utilizzo</a></div>
         </div>
      </form>

   </div>
</div>

<app-popup-generic [autoclose]="false"
                   [mode]="'normal'"
                   [(visible)]="popupTermsVisible"
                   [width]="'700'"
                   [content]="termsTemplate"
                   [buttons]="popupTermsButtons"
                   [title]="'Termini e Condizioni di Utilizzo'">
</app-popup-generic>

<ng-template #termsTemplate>
   <div class="container mt-10" [innerHTML]="termsConditions.terms"></div>
</ng-template>

